import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
	settingsId: string;
	onChange: (value: string) => void;
}

export const CheckoutUrlPrefixField: React.FC<IProps> = React.memo(({ onChange, settingsId }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterCheckoutUrlPrefix') }], [t]);

	return (
		<FormInput
			testId="CheckoutUrlPrefixField"
			name={`checkoutUrlPrefix-${settingsId}`}
			label="checkoutUrlPrefixLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
});
